// extracted by mini-css-extract-plugin
module.exports = {"benefitCard":"Benefit_benefitCard__ZIz3Y","imgContainer":"Benefit_imgContainer__c44Gt","contentData":"Benefit_contentData__qDf3N"};